<template>
    <section class="choose-plan-popup">
        <a @click="$router.go(-1)" class="profile-edit-close-btn">
            <img src="/assets/img/close-icon.svg"/>
        </a>
        <div class="choose-plan-wrapper">
            <div class="save-document-form">
                <h2>Choose a Plan</h2>
                <p>Get the features you need to succeed and take your Power BI activities to the next level.</p>

                    <div class="container" v-if="current_plan">
                        <div class="row align-items-end">
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="choose-plan-columns" :class="{ 'current-plan' : current_plan == 'essentials' }">
                                    <h4>Essentials</h4>
                                    <h6></h6>
                                    <h2>Free</h2>
                                    <p>Forever</p>
                                    <p>For individuals fond of<br> Power BI</p>
                                    <ul>
                                        <li class="active">All Apps Access</li>
                                        <li class="active">Save up to 3 Documents</li>
                                        <li>Community Access</li>
                                        <li>Project Spaces</li>
                                        <li>Beta Features Access</li>
                                        <li>Private Projects</li>
                                        <li>Up to 5 Team Members</li>
                                        <li>Team Management Tools</li>
                                        <li>Optional Premium Support</li>
                                        <li>Feature Requests</li>
                                        <li>Dedicated Customer Success Representative</li>
                                    </ul>
                                    <div class="choose-plan-btn">
                                        <h4>Your current plan</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="choose-plan-columns best-seller-plan" :class="{ 'current-plan' : current_plan == 'professional' }">
                                    <div class="best-seller-tag">BEST SELLER</div>
                                    <h4>Professional</h4>
                                    <h6 :class="{ 'invisible' : !sub_yearly }">Save 20% a year</h6>
                                    <h2 v-if="sub_yearly"><sup>$</sup>{{ yearly_prices.professional }}</h2>
                                    <h2 v-else><sup>$</sup>{{ monthly_prices.professional }}</h2>
                                    <p>per month</p>
                                    <p>For individuals working on multiple projects</p>
                                    <ul>
                                        <li class="active">All Apps Access</li>
                                        <li class="active"><strong>Unlimited Documents</strong></li>
                                        <li class="active">Community Access</li>
                                        <li class="active">Project Spaces</li>
                                        <li class="active">Beta Features Access</li>
                                        <li class="active">Private Projects</li>
                                        <li class="active"><strong>Teams</strong></li>
                                        <li>Team Management Tools</li>
                                        <li>Optional Premium Support</li>
                                        <li>Feature Requests</li>
                                        <li>Dedicated Customer Success Representative</li>
                                    </ul>
                                    <div class="choose-plan-btn">
                                        <h4>Your current plan</h4>
                                        <button class="btn btn-rounded-primary" @click="subscribe('professional')">Choose Professional</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <div class="choose-plan-columns enterprise-plan" :class="{ 'current-plan' : current_plan == 'enterprise' }">
                                    <h4>Enterprise</h4>
                                    <h6></h6>
                                    <h4 class="choose-plan-title">Contact us<br> for pricing</h4>
                                    <p>For organizations with advanced collaborative needs</p>
                                    <ul>
                                        <li class="active">All Apps Access</li>
                                        <li class="active"><strong>Unlimited Documents</strong></li>
                                        <li class="active">Community Access</li>
                                        <li class="active">Project Spaces</li>
                                        <li class="active">Beta Features Access</li>
                                        <li class="active">Private Projects</li>
                                        <li class="active"><strong>Teams</strong></li>
                                        <li class="active">Team Management Tools</li>
                                        <li class="active">Optional Premium Support</li>
                                        <li class="active">Feature Requests</li>
                                        <li class="active">Dedicated Customer Success Representative</li>
                                    </ul>
                                    <div class="choose-plan-btn">
                                        <h4>Your current plan</h4>
                                        <a class="btn btn-rounded-primary" href="mailto:analysthub@enterprisedna.co">Choose Enterprise</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="choose-plan-yearly">
                                    <h3>MONTHLY</h3>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" v-model="sub_yearly" class="custom-control-input" id="Automatic">
                                        <label class="custom-control-label" for="Automatic"></label>
                                    </div>
                                    <h4><span>Save 20%</span>YEARLY</h4>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </section>
</template>

<script>
import ApiService from "../api/api.service";
import {mapGetters} from "vuex";

export default {
    name: "SubscriptionPlans",
    data: () => {
        return  {
            sub_yearly: true,
            monthly_prices: {
                professional: 21,
                team: 90,
            },
            yearly_prices: {
                professional: 17,
                team: 75,
            },
            current_plan: 'essentials',
            current_plan_status: 'active',
            user_id: 'essentials',
        }
    },
    mounted() {
        ApiService.setHeader();
        ApiService.get('/api/user').then(({data}) => {
            if(!data.free_plan) {
                this.current_plan = data.subscription_code;
                this.current_plan_status = data.subscription_status;
            }
            this.user_id = data.id;
        }).catch(error => {
            throw new Error('failed to load user');
        });
    },
    computed : {
        ...mapGetters({
            isLoggedIn : "isLoggedIn"
        })
    },
    methods: {
        subscribe: function (val) {
            let data = {
                plan: val,
                period: this.sub_yearly ? 'yearly' : 'monthly'
            };
            if (this.isLoggedIn) {
                if(this.current_plan != 'essentials' &&
                    (this.current_plan_status == 'active' ||
                    this.current_plan_status == 'in_trail' )
                ) {
                    window.location = process.env.MIX_APP_CHARGEBEE_PORTAL_URL;
                } else {
                    // upgrade from essential
                    window.location = process.env.MIX_APP_CHARGEBEE_URL + 'hosted_pages/plans/'+data.plan+'-'+data.period+'?customer[id]=AH-'+this.user_id;
                }

            } else {
                window.location = '/login';
            }
        },
    }
}
</script>

<style scoped>

</style>
